import { SummaryType } from '@ls/grouping-service';
import { produce } from 'immer';
import { deleteDefinition } from 'state/grid/util';
import { COMMIT_SELECTIONS } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import { RECEIVE_GRID_DATA, REQUEST_GRID_DATA, REQUEST_VAR_SBS_DATA, RECEIVE_VAR_SBS_DATA, SET_DEFINITION, SET_DEFINITIONS, DELETE_DEFINITION } from './actions';

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingVarSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  varSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  options: [
    {
      label: 'PARAM',
      value: 'PARAM',
    },
    {
      label: 'MONTE_CARLO',
      value: 'MONTE_CARLO',
    },
  ],
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }
    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_GRID_DATA: {
      state.fetchingData[action.summary] = true;
      state.data[action.summary] = defaultState.data[action.summary];
      break;
    }
    case RECEIVE_GRID_DATA: {
      state.fetchingData[action.summary] = false;
      state.data[action.summary] = action.data;
      break;
    }
    case REQUEST_VAR_SBS_DATA: {
      state.fetchingVarSbsData[action.summary] = true;
      state.varSbsData[action.summary] =
        defaultState.varSbsData[action.summary];

      break;
    }
    case RECEIVE_VAR_SBS_DATA: {
      state.fetchingVarSbsData[action.summary] = false;
      state.varSbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
